import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { Typography, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      minHeight: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    },
    mt16: {
      marginTop: "16px"
    }
  };
});

var InvalidTemplate = function InvalidTemplate(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(ErrorOutlineIcon, {
    fontSize: "large"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.mt16
  }, props.text || "Invalid"), props.button ? props.button.link ? /*#__PURE__*/React.createElement(Button, {
    className: classes.mt16,
    component: Link,
    to: props.button.link,
    variant: "outlined",
    color: "secondary"
  }, props.button.label || "Undefined") : /*#__PURE__*/React.createElement(Button, {
    className: classes.mt16,
    variant: "outlined",
    color: "secondary",
    onClick: props.onClick
  }, props.button.label || "Undefined") : null);
};

export { InvalidTemplate };